import { DEFAULT_CHARACTER_ID } from "@shared/characterCatalog.js";

export function resolveLocalProjectileRemoteContact(scene, proj, { aabbOverlap }) {
  if (!scene || !proj || proj.markedForRemoval) return false;
  if (!aabbOverlap) return false;
  const dtScale = scene.frameScale || 1;
  const currCenterX = proj.x + proj.w / 2;
  const currCenterY = proj.y + proj.h / 2;
  const dx = (Number.isFinite(proj.speed) ? proj.speed : 0) * dtScale;
  const prevCenterX = currCenterX - dx;
  const halfW = proj.w / 2;
  const halfH = proj.h / 2;

  for (const remote of scene.remotePlayers.values()) {
    const sprite = remote.sprite;
    if (!sprite) continue;
    const remoteFootOffset = scene.getCharacterFootOffset(remote.characterId || DEFAULT_CHARACTER_ID);
    const remoteCenterOffsetX = scene.getCharacterCenterOffsetX(remote.characterId || DEFAULT_CHARACTER_ID);
    const remoteCenterX = sprite.x + remoteCenterOffsetX;
    const playerBox = {
      x: remoteCenterX - 14,
      y: sprite.y - 40 - remoteFootOffset,
      w: 28,
      h: 40,
    };

    const verticalOverlap = !(currCenterY + halfH <= playerBox.y || currCenterY - halfH >= playerBox.y + playerBox.h);
    if (!verticalOverlap) continue;

    let hit = false;
    let hitCenterX = currCenterX;
    if (dx > 0) {
      const prevFront = prevCenterX + halfW;
      const currFront = currCenterX + halfW;
      const targetEdge = playerBox.x;
      if (prevFront <= targetEdge && currFront >= targetEdge) {
        hit = true;
        hitCenterX = targetEdge - halfW;
      }
    } else if (dx < 0) {
      const prevFront = prevCenterX - halfW;
      const currFront = currCenterX - halfW;
      const targetEdge = playerBox.x + playerBox.w;
      if (prevFront >= targetEdge && currFront <= targetEdge) {
        hit = true;
        hitCenterX = targetEdge + halfW;
      }
    }

    if (!hit) {
      const overlapNow = aabbOverlap(
        { x: currCenterX - halfW, y: currCenterY - halfH, w: proj.w, h: proj.h },
        playerBox
      );
      if (!overlapNow) continue;
      hit = true;
      hitCenterX = dx >= 0 ? (playerBox.x - halfW) : (playerBox.x + playerBox.w + halfW);
    }

    const hitCenterY = Math.max(
      playerBox.y + halfH,
      Math.min(playerBox.y + playerBox.h - halfH, currCenterY)
    );
    proj.x = hitCenterX - halfW;
    proj.y = hitCenterY - halfH;
    if (proj.sprite) {
      proj.sprite.x = hitCenterX;
      proj.sprite.y = hitCenterY;
    }
    proj.markedForRemoval = true;
    proj.destroy();
    if (proj.networkProjectileId != null) {
      scene.netProjectilesById.delete(String(proj.networkProjectileId));
    }
    if (proj.networkSpawnToken) {
      scene.netPendingProjectilesByToken.delete(String(proj.networkSpawnToken));
    }
    return true;
  }
  return false;
}
